module.exports = __webpack_public_path__ + "img/hrdag_logo.021cd4ee.png";